import { PRESENTATION_MODE_EVENTS } from '@/content/values/ed-presentation-mode.values';
import EdTeacherMeetingTransparency from '@/core/components/ed-meeting-transparency/ed-teacher-meeting-transparency/ed-teacher-meeting-transparency.component.vue';
import EdStudentMeetingTransparency from '@/core/components/ed-meeting-transparency/ed-student-meeting-transparency/ed-student-meeting-transparency.component.vue';
import { SECTION_TYPE_CODES } from '@/core/values/ed-transparency-meeting.values';
import {_COURSE_STORE} from '@/courses/enums/courses.enum';
import EdPresentationModeResize from '@/content/components/ed-presentation-mode/ed-presentation-mode-tools/ed-presentation-mode-resize';

import { ScreenMirroringMixin } from '@/screen-mirroring/mixins/screen-mirroring.mixin';

export default {
  name: 'ed-images-viewer',
  props: {
    'section': {},
    'documentIndex': {
      type: Number,
      default: 0
    }
  },
  components: {
    EdTeacherMeetingTransparency,
    EdStudentMeetingTransparency
  },
  mixins: [ScreenMirroringMixin],
  data(){
    return {
      imagesLoaded: 0,
      pagesLoaded: false
    }
  },
  computed: {
    images() {
      return this.section.assetsInfo ? this.section.assetsInfo.filter(a => a.hash ? true : false) : [];
    },
    description() {
      return (this.section.description && this.section.description != 'null') ? this.section.description : '';
    },
    isPresentationMode(){
      return this.$store.state.CourseStore.isPresentationStudentMode || this.$store.state.CourseStore.isPresentationTeacherMode;
    },
    isPresentationTeacherMode() {
      return this.$store.state.CourseStore.isPresentationTeacherMode;
    },
    isWhiteboardTransparency() {
      return this.$store.state.MeetingsStore.isWhiteboardTransparency;
    },
    isPresentationStudentMode() {
      return this.$store.state.CourseStore.isPresentationStudentMode;
    },
    courseSelected() {
      return this.$store.state.CourseStore.presentationCourseSelected;
    },
    presentationModePageSizeInfo() {
      return this.$store.state.MeetingsStore.presentationModePageSizeInfo;
    },
    isSameCourse() {
      return this.courseSelected === this.section.courseId;
    },
    refStudent() {
      return this.$refs.studentTransparency;
    },
    changeData() {
      const { refStudent } = this
      return {
        refStudent
      }
    },
    documentHash() {
      // desired length of Id
      var idStrLen = 32;
      // always start with a letter -- base 36 makes for a nice shortcut
      var idStr = (Math.floor((Math.random() * 25)) + 10).toString(36) + '_';
      // add a timestamp in milliseconds (base 36 again) as the base
      idStr += (new Date()).getTime().toString(36) + '_';
      // similar to above, complete the Id using random, alphanumeric characters
      do {
          idStr += (Math.floor((Math.random() * 35))).toString(36);
      } while (idStr.length < idStrLen);

      return (idStr);
    }
  },
  watch: {
    changeData: {
      handler: function(val) {
        this.loadingPage();
      },
      deep: true
    }
  },
  methods: {
    imgLoaded() {
      this.imagesLoaded++;
      if(this.imagesLoaded === this.images.length){
        this.$edEventBus.$emit(PRESENTATION_MODE_EVENTS.LOAD_PRESENTATION_ELEMENTS);
        this.$Courses.Store.setImagesLoading(false);
      }
    },
    loadingPage() : void {
      if((document.querySelectorAll('.page-image')[0] as HTMLImageElement)?.offsetHeight == 0) {
        setTimeout(() => {
          this.loadingPage();
        }, 200);
      } else {
        this.resizeImages();
        const transparencyRef = this.$refs.teacherTransparency || this.$refs.studentTransparency;
        if(transparencyRef && !this.pagesLoaded) {
          this.images.forEach((image, index) => {
            let imageElement : any = document.querySelectorAll('.page-image')[index];
            let data = { height: imageElement.offsetHeight, width: imageElement.offsetWidth, sectionType: SECTION_TYPE_CODES.LESSON_IMAGES, page: index + 1 };
            transparencyRef.loadingPage(data);
            this.$Meetings.Store.updateOriginalPagesSize({ documentHash: this.documentHash, pageNumber: index + 1, data});
          });
          this.pagesLoaded = true;
          this.$Meetings.Store.updateLoadedBoardsInDom(0);
        }
      }
    },
    resizeImages() {
      if (!this.isPresentationStudentMode) return;

      const presenterContainerWidth = this.presentationModePageSizeInfo?.teacherWidth;
      if (!presenterContainerWidth) {
        return;
      }
      
      const imageElements = document.querySelectorAll('.page-image') as NodeListOf<HTMLImageElement>;
      if (!imageElements || imageElements.length === 0) {
        setTimeout(() => this.resizeImages(), 200);
        return;
      }
      
      imageElements.forEach((imageElement, index) => {
        if (!imageElement.complete || imageElement.naturalWidth === 0) {
          // If image isn't fully loaded yet, wait for it
          imageElement.onload = () => {
            this.applyScaleToImage(imageElement, presenterContainerWidth, index);
          };
        } else {
          // Image is loaded, apply scale immediately
          this.applyScaleToImage(imageElement, presenterContainerWidth, index);
        }
      });
    },
    applyScaleToImage(imageElement, presenterContainerWidth, index) {
      // Calculate scale based on the natural width of the image
      const scale = EdPresentationModeResize.calculateImageScale(
        presenterContainerWidth,
        imageElement.naturalWidth
      );

      imageElement.style.width = `${scale * imageElement.naturalWidth}px`;
    }
  },
  mounted() {
    this.loadingPage();
    this.$Courses.Store.setImagesLoading(true);
  },
  updated() {
    this.loadingPage();
  }
};
